export default "__VITE_ASSET__D41Uro7U__"